var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#0CA7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8948 50.1053V46.5263H39.3685V50.1053H17.8948ZM28.0053 41.4263L17.8948 31.3158L21.6527 27.4684L31.8527 37.579L28.0053 41.4263ZM39.3685 30.0632L29.2579 19.8632L33.1053 16.1053L43.2158 26.2158L39.3685 30.0632ZM47.6 48.3158L24.2474 24.9632L26.7527 22.4579L50.1053 45.8105L47.6 48.3158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterCheck);
export default __webpack_public_path__ + "static/media/letter-check.2746cdafb7d25ffafa20b614e96304f1.svg";
export { ForwardRef as ReactComponent };